module.exports = __webpack_public_path__ + "assets/fonts/cog.1d0d7ed8.svg";